import { commonStyles } from '../commonStyles';
import { MessageVariantType } from '../variants';
export const getInformativeStyles = (FOUNDATIONS, FONT) => {
    return {
        [MessageVariantType.INFORMATIVE]: {
            ...commonStyles(FOUNDATIONS, FONT),
            container: {
                ...commonStyles(FOUNDATIONS, FONT).container,
                background_color: FOUNDATIONS.color_feedback_info_bg_150,
                border_color: FOUNDATIONS.color_feedback_info_border_50,
            },
            infoIcon: {
                ...commonStyles(FOUNDATIONS, FONT).infoIcon,
                color: FOUNDATIONS.color_feedback_info_icon_50,
            },
        },
    };
};
//# sourceMappingURL=informative.js.map